<template>
    <div class="content">
        <h2 id="produtos-relacionados" class="section-title">Produtos Relacionados</h2>
        <ProductList
            :products="products"
            event-name="Product detail similar"
            list-class="product-horizontal-list product-horizontal-list-4 no-scrollbar"
            @scroll="scrollEvent = $event"
        />
        <HorizontalScrollbar
            v-if="products.length > 2"
            :scroll-event="scrollEvent"
            class="hidden-not-touch"
        />
    </div>
</template>

<script>
    import ProductList from '../../../submodules/src/componentsV2/common/ProductList';
    import HorizontalScrollbar from '../common/container/HorizontalScrollbar';

    export default {
        name: 'ProductRelated',

        components: { ProductList, HorizontalScrollbar },

        props: {
            products: {
                type: Array,
                required: true,
            },
        },

        data() {
            return {
                scrollEvent: null,
            };
        },
    };
</script>
